export function* map<T, TResult>(
  collection: Iterable<T>,
  project: (item: T) => TResult
): Iterable<TResult> {
  for (const item of collection) {
    yield project(item);
  }
}
